import { ILoaderFactory, ILoader, loaderSettings } from "./ILoader";
import { ChildElementDisablerLoader } from "./ChildElementDisablerLoader";

export class DefaultLoaderFactory implements ILoaderFactory {

    constructor() {
    
    }
    create(loaderElement: any, elements: any, hideElement: any, settings: loaderSettings): ILoader {
        return new ChildElementDisablerLoader(loaderElement, elements, hideElement, settings);
    }
}